import React, { MouseEvent } from 'react';
import { IntlShape } from 'react-intl';
import WelcomeHeaderDropdownButton from './WelcomeHeaderHomeDropdownButton';

interface RenderTopicsButtonProps {
  isVisible: boolean;
  onButtonClick: (
    event: MouseEvent<HTMLDivElement> | MouseEvent<HTMLButtonElement>,
  ) => void;
  dropdownText: React.ReactNode;
  intl: IntlShape;
  buttonRef?: React.Ref<HTMLButtonElement> | null;
}

/**
 * Renders a dropdown button for toggling video topics in the welcome header.
 * Displays different button styles based on whether search results are open.
 */
const WelcomeHeaderTopicsDropdownButtonInner = ({
  intl,
  isVisible,
  onButtonClick,
  dropdownText,
  buttonRef,
}: RenderTopicsButtonProps) => {
  return (
    <WelcomeHeaderDropdownButton
      ref={buttonRef}
      isVisible={isVisible}
      onClick={onButtonClick}
      data-testid="dashboard-view-all-topics-button"
      aria-label={intl.formatMessage({
        defaultMessage: 'Toggle video topics',
        id: 'dashboard.header.toggle.video.topics',
      })}
      aria-controls="header-topic-dropdown"
    >
      {dropdownText}
    </WelcomeHeaderDropdownButton>
  );
};

const WelcomeHeaderTopicsDropdownButton = React.forwardRef<
  HTMLButtonElement,
  RenderTopicsButtonProps
>(({ ...props }, ref) => {
  const innerProps = { ...props, buttonRef: ref } as RenderTopicsButtonProps & {
    buttonRef?: React.Ref<HTMLButtonElement> | null;
  };
  // pass buttonRef down to the actual button components via prop forwarding
  return <WelcomeHeaderTopicsDropdownButtonInner {...innerProps} />;
});

export default WelcomeHeaderTopicsDropdownButton;
